import { EJavaClassNames } from '@adaptiva/data-service';

export const PLATFORM_CANNOT_CREATE_CLASSNAMES: Set<EJavaClassNames> = new Set([
	EJavaClassNames.InstallableSoftware,
	EJavaClassNames.MetadataObject,
	EJavaClassNames.SoftwarePatch,
	EJavaClassNames.SoftwareProduct,
	EJavaClassNames.SoftwareRelease,
	EJavaClassNames.SoftwareReleaseGroup,
	EJavaClassNames.Workflow,
]);
